import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-719b6b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section profile-focus" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-focus__intro" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Arbeitsprofil"),
  /*#__PURE__*/_createElementVNode("h2", null, "Ich arbeite dort, wo technische Entscheidungen entstehen."),
  /*#__PURE__*/_createElementVNode("div", {
    class: "profile-focus__meta",
    "aria-label": "Rollenprofil"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Mitgründer & COO"),
    /*#__PURE__*/_createElementVNode("span", null, "Softwarearchitektur"),
    /*#__PURE__*/_createElementVNode("span", null, "KI-/RAG-Systeme")
  ])
], -1))
const _hoisted_3 = { class: "profile-focus__body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile-focus__statement" }, " Entwicklungserfahrung bleibt meine Grundlage. Der Schwerpunkt liegt heute in Analyse, Aufbau, Softwarearchitektur und Führung: nah genug an Frontend, Backend und Daten, um realistisch zu entscheiden, und nah genug an Produkt und Organisation, um Wirkung zu erzeugen. ", -1))
const _hoisted_5 = { class: "profile-focus__list" }

import { heroFocusItems } from "@/data/profile";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileFocusSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(heroFocusItems), (item, index) => {
          return (_openBlock(), _createElementBlock("article", {
            key: item.title
          }, [
            _createElementVNode("small", null, _toDisplayString(String(index + 1).padStart(2, "0")), 1),
            _createElementVNode("span", null, _toDisplayString(item.title), 1),
            _createElementVNode("p", null, _toDisplayString(item.detail), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})